import { useContext } from 'react'
import { OrdersContext, OrdersContextValue } from './OrdersContext'

export const useOrders = (): OrdersContextValue => {
    const context = useContext(OrdersContext)
    if (!context) {
        throw new Error('useOrders must be used within OrdersProvider')
    }
    return context
}
